export default {
  STORY: "story",
};
